/* Fi Akla Stage 2 storefront runtime.
 * Shopify native customer events remain authoritative for standard ecommerce events.
 * This file publishes only Fi Akla-specific events and contains no PII.
 */
(function () {
  'use strict';
  if (window.FiAklaAnalytics) return;

  var config = window.FiAklaAnalyticsConfig || {};
  var log = [];
  var pageSeen = {};
  var recent = {};
  var suppressed = 0;
  var contactSavePending = false;
  var duplicateWindow = 800;
  var storageKey = 'fi_akla_internal_traffic';
  var debug = /(?:\?|&)fi_analytics_debug=1(?:&|$)/.test(location.search);
  var params = new URLSearchParams(location.search);
  var previewTraffic = /(^|\.)shopifypreview\.com$/i.test(location.hostname) ||
    params.has('preview_theme_id') || params.has('_fd') ||
    !!(window.Shopify && Shopify.designMode);
  var pixelTest = previewTraffic && params.get('fi_pixel_test') === '1';
  var allowedPropertyKeys = {
    language: true, device_type: true, customer_type: true, traffic_type: true, page_type: true,
    category: true, filter: true, filter_name: true, filter_value: true, selected: true,
    product_id: true, product_handle: true, variant_id: true, product_type: true,
    menu_week: true, meal_pass_eligible: true, plan: true, placement: true, package: true,
    source: true, validation_type: true, portion: true, quantity: true, option: true,
    delivery_day: true, delivery_date: true, delivery_window: true, delivery_area: true,
    from_language: true, to_language: true, option_type: true, option_value: true,
    reason: true, service_handle: true, covers: true, extra_mains: true, extra_sides: true,
    collection_handle: true
  };

  if (params.get('fi_internal') === '1') {
    try { localStorage.setItem(storageKey, '1'); } catch (e) {}
  } else if (params.get('fi_internal') === '0') {
    try { localStorage.removeItem(storageKey); } catch (e) {}
  }

  function internalTraffic() {
    if (previewTraffic) return true;
    try { return localStorage.getItem(storageKey) === '1'; } catch (e) { return false; }
  }

  function deviceType() {
    return matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  }

  function clean(value) {
    if (value === undefined || value === null || value === '') return undefined;
    if (typeof value === 'string') return value.trim().replace(/\s+/g, ' ').slice(0, 160);
    return value;
  }

  function safeProperties(properties) {
    var output = {
      language: clean(config.language || document.documentElement.lang || 'en'),
      device_type: deviceType(),
      customer_type: clean(config.customerType || 'guest'),
      traffic_type: internalTraffic() ? 'internal' : 'external',
      page_type: clean(document.querySelector('main[data-template]') && document.querySelector('main[data-template]').dataset.template)
    };
    Object.keys(properties || {}).forEach(function (key) {
      if (!allowedPropertyKeys[key]) return;
      if (/allerg|address|phone|pin|note|email|name/i.test(key)) return;
      var value = clean(properties[key]);
      if (value !== undefined) output[key] = value;
    });
    return output;
  }

  function signature(name, properties) {
    var keys = Object.keys(properties).sort();
    return name + '|' + keys.map(function (key) {
      return key + ':' + String(properties[key]);
    }).join('|');
  }

  function duplicate(name, properties) {
    var now = Date.now();
    var key = signature(name, properties);
    if (recent[key] && now - recent[key] < duplicateWindow) {
      suppressed += 1;
      if (debug) console.info('[Fi Akla analytics: duplicate suppressed] ' + name);
      return true;
    }
    recent[key] = now;
    Object.keys(recent).forEach(function (recentKey) {
      if (now - recent[recentKey] > 5000) delete recent[recentKey];
    });
    return false;
  }

  function syncTestOrderMarker() {
    var shouldMark = internalTraffic();
    var explicitlyCleared = params.get('fi_internal') === '0';
    if (!shouldMark && !explicitlyCleared) return;
    var value = shouldMark ? 'Test / internal' : '';
    var route = config.cartUpdateUrl || '/cart/update.js';
    var root = window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
    fetch(root + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart marker read failed');
      return response.json();
    }).then(function (cart) {
      if ((cart.attributes || {})['Fi Akla order type'] === value) return null;
      return fetch(route, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Fi Akla order type': value } })
      });
    }).then(function (response) {
      if (!response) return;
      if (!response.ok) throw new Error('Cart marker request failed');
      if (debug) console.info('[Fi Akla analytics] Test-order marker ' + (shouldMark ? 'set' : 'cleared'));
    }).catch(function (error) {
      if (debug) console.warn('[Fi Akla analytics] Test-order marker failed', error);
    });
  }

  function publish(name, properties) {
    var safe = safeProperties(properties);
    if (duplicate(name, safe)) return false;
    var record = { event: name, properties: safe, at: new Date().toISOString() };
    log.push(record);
    if (log.length > 100) log.shift();

    if (internalTraffic() && !pixelTest) {
      if (debug) console.info('[Fi Akla analytics: internal, not published] ' + name + ' ' + JSON.stringify(record.properties));
      return true;
    }

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try { Shopify.analytics.publish(name, record.properties); } catch (error) {
        console.warn('[Fi Akla analytics] Shopify publish failed', error);
      }
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, record.properties));
    }
    if (debug) console.info('[Fi Akla analytics] ' + name + ' ' + JSON.stringify(record.properties));
    return true;
  }

  function publishPageOnce(name, properties) {
    if (pageSeen[name]) return;
    pageSeen[name] = true;
    publish(name, properties);
  }

  function text(target) {
    return (target && (target.dataset.label || target.value || target.textContent) || '').trim();
  }

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function favouriteActive(favourite) {
    return favourite && (
      favourite.getAttribute('aria-pressed') === 'true' ||
      favourite.getAttribute('aria-label') === 'Saved' ||
      favourite.classList.contains('active')
    );
  }

  function ensureFavouriteFeedbackStyles() {
    if (document.getElementById('FiAklaFavouriteFeedbackStyles')) return;
    var style = document.createElement('style');
    style.id = 'FiAklaFavouriteFeedbackStyles';
    style.textContent =
      '[data-fi-wishlist-optimistic] button{position:relative;transition:transform .16s ease,background-color .16s ease}' +
      '[data-fi-wishlist-optimistic="saved"] button{background:#fd5c02!important;color:#fffaf0!important;transform:scale(1.06)}' +
      '[data-fi-wishlist-optimistic="removed"] button{transform:scale(.94)}' +
      '[data-fi-wishlist-optimistic="saved"] .abibo-wl-heart{font-size:0!important}' +
      '[data-fi-wishlist-optimistic="saved"] .abibo-wl-heart::after{content:"\u2665";font-size:1.75rem;line-height:1}' +
      '@media(prefers-reduced-motion:reduce){[data-fi-wishlist-optimistic] button{transition:none}}';
    document.head.appendChild(style);
  }

  function optimisticFavouriteFeedback(favourite, wasActive) {
    var host = closest(favourite, '.abibo-wl-save, [data-wishlist], [data-favourite]') || favourite;
    var desiredActive = !wasActive;
    ensureFavouriteFeedbackStyles();
    host.setAttribute('data-fi-wishlist-optimistic', desiredActive ? 'saved' : 'removed');
    var heart = host.querySelector('.abibo-wl-heart');
    if (heart) heart.textContent = desiredActive ? '♥' : '♡';

    var finished = false;
    var observer = new MutationObserver(function () {
      var currentButton = host.querySelector('button') || favourite;
      if (favouriteActive(currentButton) !== desiredActive) return;
      finished = true;
      observer.disconnect();
      window.setTimeout(function () { host.removeAttribute('data-fi-wishlist-optimistic'); }, 180);
    });
    observer.observe(host, { attributes: true, childList: true, subtree: true, attributeFilter: ['aria-pressed', 'aria-label', 'class'] });
    window.setTimeout(function () {
      if (!finished) observer.disconnect();
      host.removeAttribute('data-fi-wishlist-optimistic');
    }, 8000);
  }

  function productData(target) {
    var card = closest(target, '[data-product-id], product-card, .product-card, [data-product-card], article');
    var productLink = card && card.querySelector('a[href*="/products/"]');
    var productHandle = productLink && productLink.getAttribute('href').split('/products/')[1];
    var form = closest(target, 'form');
    var variantControl = form && form.querySelector('[name="id"]');
    return {
      product_id: card && (card.dataset.productId || card.getAttribute('data-product-id')) || config.productId,
      product_handle: productHandle && productHandle.split(/[?#]/)[0] || config.productHandle,
      variant_id: target && target.dataset && target.dataset.variantId ||
        target && target.matches && target.matches('[name="id"]') && target.value ||
        variantControl && variantControl.value,
      product_type: card && card.dataset.productType,
      menu_week: card && card.dataset.menuWeek,
      meal_pass_eligible: !!closest(target, '[data-meal-pass-eligible]')
    };
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var mealPassCredit = closest(target, '[data-fi-meal-pass-credit]');
    if (mealPassCredit) publish('meal_pass_credit_selected', { source: 'account_hub' });

    var category = closest(target, '[data-menu-category], [data-category], collection-links-component a');
    if (!category && /\/collections\//.test(location.pathname)) {
      category = closest(target, 'button[aria-pressed]');
    }
    if (category) publish('menu_category_selected', { category: text(category) });

    var clear = closest(target, '.clear-filter, [data-clear-filters], facet-remove-component a');
    if (clear) publish('menu_filter_cleared', { filter: text(clear) || 'all' });

    var dishLink = closest(target, 'a[href*="/products/"]');
    if (dishLink && /\/collections\/(?:this-week-s-menu|this-weeks-menu)/.test(location.pathname) && !closest(dishLink, '[id^="FiAklaMealPass-"]')) {
      publish('dish_selected', productData(dishLink));
    }

    var favourite = closest(target, '[data-favourite], [data-wishlist], .wishlist-button, .abibo-wl-save button, button[aria-label*="avourite" i], button[aria-label="Save"], button[aria-label*="saved" i]');
    if (favourite) {
      var wasActive = favouriteActive(favourite);
      optimisticFavouriteFeedback(favourite, wasActive);
      var favouriteProperties = productData(favourite);
      setTimeout(function () {
        var isActive = favouriteActive(favourite);
        if (isActive !== wasActive) publish(isActive ? 'favourite_added' : 'favourite_removed', favouriteProperties);
      }, 300);
    }

    var mealPlan = closest(target, '[data-meal-pass-plan], [data-pass-plan], .fi-ticket, button[name*="meal_pass"]');
    if (mealPlan) {
      var weeks = mealPlan.querySelector && mealPlan.querySelector('.fi-ticket__top strong');
      publish('meal_pass_plan_selected', { plan: weeks ? weeks.textContent.trim() + '_weeks' : text(mealPlan) });
    } else {
      var mealPassCta = closest(target, 'a[href*="/products/fi-akla-meal-pass"]');
      if (mealPassCta) publish('meal_pass_cta_clicked', { placement: closest(mealPassCta, '[id^="FiAklaMealPass-"]') ? 'meal_pass_section' : 'navigation' });
    }

    var invitePackage = closest(target, '[data-invite-package], [data-package], a[href*="invite-us-over-"]');
    if (invitePackage) {
      var packageHandle = invitePackage.getAttribute('href') && invitePackage.getAttribute('href').split('/products/')[1];
      publish('invite_package_selected', { package: packageHandle && packageHandle.split(/[?#]/)[0] || text(invitePackage) });
    }

    var inviteDate = closest(target, '[data-check-availability], [data-invite-date-check]');
    if (inviteDate) publish('invite_date_checked', { source: 'invite_us_over' });

    var checkout = closest(target, '[name="checkout"], [data-checkout]');
    if (checkout) {
      publish('cart_checkout_clicked', {});
      setTimeout(function () {
        var visibleError = document.querySelector('[data-fi-contact-error]:not([hidden]), [data-fi-slot-error]:not([hidden]), [id^="CartDrawer-"][id$="Error"]:not([hidden]), [aria-invalid="true"]');
        if (visibleError) publish('cart_validation_failed', { validation_type: visibleError.dataset.fiContactError || visibleError.dataset.fiSlotError || 'cart_field' });
      }, 0);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var isMealPassSelect = /\/products\/fi-akla-meal-pass/.test(location.pathname) && target.matches('select');

    if (target.matches('.facets input, [data-filter] input, select[name*="filter"]') ||
        (/\/collections\//.test(location.pathname) && target.matches('select'))) {
      publish('menu_filter_used', { filter_name: target.name, filter_value: text(target), selected: !!target.checked || target.tagName === 'SELECT' });
    }

    if (!isMealPassSelect && target.matches('[name*="portion" i], [data-portion] input, select[data-portion], .fi-product__select, .fi-akla-detailed-card__variant-select')) {
      publish('portion_selected', Object.assign(productData(target), { portion: text(target) }));
    }

    if (target.matches('.fi-product__quantity-input, .fi-akla-detailed-card__qty-input')) {
      publish('portion_quantity_changed', Object.assign(productData(target), { quantity: Number(target.value) || 1 }));
    }

    var labelText = target.labels && target.labels.length ? target.labels[0].textContent : '';
    if (target.matches('[name*="extra protein" i], [name*="extra_protein" i], [data-extra-protein] input, [data-fi-extra-protein]') ||
        (target.matches('input[type="checkbox"]') && /extra protein/i.test(labelText))) {
      publish('extra_protein_selected', Object.assign(productData(target), { selected: !!target.checked, option: labelText.trim() || text(target) }));
    }

    if (target.matches('select[name="attributes[Delivery slot]"], #CartDrawer-DeliverySlot')) {
      var selected = target.options[target.selectedIndex];
      publish('delivery_window_selected', {
        delivery_day: selected && (selected.dataset.date || selected.textContent.split('·')[0].trim()),
        delivery_window: selected && (selected.dataset.window || selected.textContent.split('·')[1] || '')
      });
      publish('delivery_date_selected', {
        delivery_date: selected && (selected.dataset.date || selected.textContent.split('·')[0].trim())
      });
    }

    if (target.matches('[data-fi-delivery-area]')) {
      var option = target.options[target.selectedIndex];
      if (option && option.value && option.dataset.zone) {
        publish('delivery_area_selected', { delivery_area: option.textContent.trim() });
      } else if (option && option.value) {
        publish('delivery_area_rejected', { source: 'delivery_area_selector' });
      }
    }

    if (isMealPassSelect) {
      var mealPassOption = target.options[target.selectedIndex];
      publish('meal_pass_plan_selected', { plan: mealPassOption && mealPassOption.textContent.trim(), variant_id: target.value });
    }

    if (target.matches('select[name="locale_code"], [data-localization-form] select')) {
      publish('language_changed', { from_language: document.documentElement.lang, to_language: target.value });
    }

    if (target.matches('[data-iou-option], [data-iou-extra-mains], [data-iou-extra-sides], [data-iou-chef]')) {
      publish('invite_option_selected', {
        option_type: target.dataset.optionName || target.name && target.name.replace(/^properties\[|\]$/g, '') || 'booking_option',
        option_value: text(target)
      });
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (closest(event.target, '.fi-product__form, .fi-akla-detailed-card__form')) publishPageOnce('dish_form_started', productData(event.target));
    if (closest(event.target, '[data-fi-feedback-page]')) publishPageOnce('feedback_started', {});
  }, true);

  window.fiAklaRefreshCartDrawer = async function () {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    var response = await fetch(root + '?section_id=cart-drawer-section&_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    });
    if (!response.ok) throw new Error('Unable to refresh cart drawer');

    var documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    var freshComponent = documentFragment.querySelector('cart-drawer-component');
    var currentComponent = document.querySelector('cart-drawer-component');
    if (freshComponent && currentComponent) {
      currentComponent.replaceWith(document.importNode(freshComponent, true));
    }

    var cartResponse = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    var cart = await cartResponse.json();
    document.querySelectorAll('cart-icon').forEach(function (cartIcon) {
      if (cartIcon.renderCartBubble) cartIcon.renderCartBubble(cart.item_count);
    });
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-fi-past-request]') && form.checkValidity()) {
      publish('comeback_requested', productData(form));
      publish('comeback_request_submitted', Object.assign(productData(form), { source: 'past_menu' }));
    }
    if (form.matches('.fi-product__form, .fi-akla-detailed-card__form')) publish('dish_add_attempted', productData(form));
  }, true);

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.fi-akla-detailed-card__form')) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button && button.disabled) return;
    if (button) button.disabled = true;
    try {
      var response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add item');
      await window.fiAklaRefreshCartDrawer();
      var drawer = document.querySelector('cart-drawer-component');
      drawer = drawer && drawer.closest('theme-drawer');
      if (drawer && drawer.open) drawer.open();
    } catch (error) {
      console.error('[Fi Akla] Add to cart failed.', error);
    } finally {
      if (button) button.disabled = false;
    }
  });

  document.addEventListener('fi-akla:slot-unavailable', function () {
    publish('invite_slot_unavailable', { source: 'invite_us_over' });
  });
  document.addEventListener('fi-akla:meal-pass-code-applied', function () {
    publish('meal_pass_code_applied', {});
    publish('meal_pass_credit_applied', { source: 'account_hub' });
  });
  document.addEventListener('fi-akla:meal-pass-code-failed', function (event) {
    publish('meal_pass_code_failed', { reason: event.detail && event.detail.reason });
  });
  document.addEventListener('fi-akla:feedback-submitted', function () {
    publish('feedback_submitted', {});
  });
  document.addEventListener('fi-akla:invite-booking-started', function (event) {
    publish('invite_booking_started', event.detail || { source: 'invite_us_over' });
    publish('invite_us_over_started', event.detail || { source: 'invite_us_over' });
  });
  document.addEventListener('fi-akla:invite-booking-added', function (event) {
    publish('invite_booking_added', event.detail || { source: 'invite_us_over' });
  });
  document.addEventListener('iou:calendar-selected', function (event) {
    var detail = event.detail || {};
    publish('invite_date_selected', { source: 'invite_us_over', delivery_date: detail.date, delivery_window: detail.time });
    publish('invite_us_over_slot_selected', { source: 'invite_us_over', delivery_date: detail.date, delivery_window: detail.time });
  });
  document.addEventListener('fi-akla:contact-state', function (event) {
    var detail = event.detail || {};
    if (detail.pending) {
      contactSavePending = true;
      return;
    }
    if (detail.ready && contactSavePending) publishPageOnce('delivery_details_completed', {});
    contactSavePending = false;
  });

  // Keep the app's floating wishlist launcher in the current storefront language.
  document.addEventListener('click', function (event) {
    if (!/^ar(?:-|$)/i.test(document.documentElement.lang || '')) return;
    var launcher = closest(event.target, '.abibo-wl-launch');
    if (!launcher) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    window.location.assign((root || '/ar/').replace(/\/$/, '') + '/pages/wishlist');
  }, true);

  function localizeArabicAccessibility() {
    var isArabic = /^ar(?:-|$)/i.test(document.documentElement.lang || '');
    document.querySelectorAll('.abibo-wl-save button').forEach(function (button) {
      var saved = button.getAttribute('aria-pressed') === 'true';
      var label = isArabic ? (saved ? 'إزالة من المفضلة' : 'احفظ في المفضلة') : (saved ? 'Remove from wishlist' : 'Save to wishlist');
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    if (!/^ar(?:-|$)/i.test(document.documentElement.lang || '')) return;

    document.querySelectorAll('.fi-akla-hiw__number').forEach(function (number) {
      var value = (number.textContent || '').trim();
      var label = 'الخطوة' + (value ? ' ' + value : '');
      if (number.getAttribute('aria-label') !== label) number.setAttribute('aria-label', label);
    });

    var wishlistLauncher = document.querySelector('.abibo-wl-launch');
    if (wishlistLauncher && wishlistLauncher.getAttribute('aria-label') !== 'افتح المفضلة') {
      wishlistLauncher.setAttribute('aria-label', 'افتح المفضلة');
    }

    var wishlistHeader = document.querySelector('#abibo-wl-header-icon');
    if (wishlistHeader && wishlistHeader.getAttribute('aria-label') !== 'المفضلة') {
      wishlistHeader.setAttribute('aria-label', 'المفضلة');
    }

    var cartGuidance = document.querySelector('.fi-akla-cart-intro');
    if (cartGuidance && cartGuidance.getAttribute('aria-label') !== 'إرشادات سلة التسوق') {
      cartGuidance.setAttribute('aria-label', 'إرشادات سلة التسوق');
    }

    var fridgeImage = document.querySelector('.fi-fridge-note__image-frame img');
    if (fridgeImage && /[A-Za-z]{2,}/.test(fridgeImage.alt || '')) {
      fridgeImage.alt = 'كيس في أكلة جاهز للتوصيل';
    }
  }

  var accessibilityTimer;
  function scheduleArabicAccessibility() {
    if (accessibilityTimer) return;
    accessibilityTimer = setTimeout(function () {
      accessibilityTimer = null;
      localizeArabicAccessibility();
    }, 0);
  }

  if (typeof MutationObserver === 'function') {
    new MutationObserver(scheduleArabicAccessibility).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-pressed']
    });
  }

  function pageImpressions() {
    if (document.querySelector('[data-fi-customer-hub]')) {
      publishPageOnce('account_hub_viewed', {});
    }
    if (document.querySelector('[data-fi-meal-pass-status]')) {
      publishPageOnce('meal_pass_wallet_viewed', {});
    }
    if (/\/products\/fi-akla-meal-pass/.test(location.pathname) ||
        document.querySelector('[id^="FiAklaMealPass-"]')) {
      publishPageOnce('meal_pass_viewed', {});
    }
    if (/invite-us-over/.test(location.pathname)) {
      publishPageOnce('invite_service_viewed', {});
    }
    if (/\/collections\/(?:this-week-s-menu|this-weeks-menu)/.test(location.pathname)) {
      publishPageOnce('weekly_menu_viewed', { collection_handle: config.collectionHandle || 'this-week-s-menu' });
    }
    if (config.productHandle && !/^fi-akla-meal-pass$|^invite-us-over-/.test(config.productHandle)) {
      publishPageOnce('dish_viewed', { product_id: config.productId, product_handle: config.productHandle });
    }
  }

  window.FiAklaAnalytics = {
    publish: publish,
    getLog: function () { return log.slice(); },
    getSuppressedCount: function () { return suppressed; },
    getDebugSummary: function () {
      var counts = {};
      log.forEach(function (record) { counts[record.event] = (counts[record.event] || 0) + 1; });
      return {
        events: counts,
        event_count: log.length,
        duplicates_suppressed: suppressed,
        internal_traffic: internalTraffic(),
        preview_traffic: previewTraffic,
        pixel_test: pixelTest
      };
    },
    isInternal: internalTraffic,
    markInternal: function () { try { localStorage.setItem(storageKey, '1'); } catch (e) {} },
    clearInternal: function () { try { localStorage.removeItem(storageKey); } catch (e) {} }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {
    syncTestOrderMarker();
    pageImpressions();
    localizeArabicAccessibility();
  }, { once: true });
  else {
    syncTestOrderMarker();
    pageImpressions();
    localizeArabicAccessibility();
  }
  document.addEventListener('shopify:section:load', function () {
    pageImpressions();
    scheduleArabicAccessibility();
  });
})();


/* Saved products must retain meal availability, variant and booking requirements. */
(function () {
  'use strict';
  var localizedTitles = new Map();
  function localizeTitle(card, title) {
    if (!title) return;
    var href = title.getAttribute('href');
    if (!href) return;
    var url;
    try { url = new URL(href, window.location.origin); } catch (_) { return; }
    if (url.origin !== window.location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var handle = url.pathname.split('/').pop();
    var endpoint = root.replace(/\/$/, '') + '/products/' + encodeURIComponent(decodeURIComponent(handle)) + '.js';
    if (!localizedTitles.has(endpoint)) {
      localizedTitles.set(endpoint, null);
      fetch(endpoint, {credentials:'same-origin', headers:{Accept:'application/json'}})
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(function (product) { localizedTitles.set(endpoint, product.title || ''); refresh(); })
        .catch(function () { localizedTitles.set(endpoint, ''); });
    }
    var translated = localizedTitles.get(endpoint);
    if (translated && title.textContent !== translated) title.textContent = translated;
    if (translated) card.querySelectorAll('img').forEach(function (image) { image.alt = translated; });
  }
  function destination(card) {
    var link = card && card.querySelector('a.abibo-wl-title[href]');
    return link && link.getAttribute('href');
  }
  function routeSavedProduct(event) {
    if (event.target.closest && event.target.closest('[data-abibo-wl-addall]')) { event.preventDefault(); event.stopImmediatePropagation(); refresh(); return; }
    var control = event.target.closest && event.target.closest('.abibo-wl-atc, .abibo-wl-atcf');
    if (!control) return;
    var href = destination(control.closest('.abibo-wl-card'));
    if (!href) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(href);
  }
  document.addEventListener('click', routeSavedProduct, true);
  document.addEventListener('submit', routeSavedProduct, true);
  function refresh() {
    var arabic = document.documentElement.lang.indexOf('ar') === 0;
    var copyNode = document.getElementById('FiAklaWishlistTranslations');
    var copy = {};
    try { copy = JSON.parse(copyNode ? copyNode.textContent : '{}'); } catch (_) {}
    [['.abibo-wl-emptyt',copy.emptyTitle],['.abibo-wl-emptys',copy.emptyBody]].forEach(function (entry) {
      if (!entry[1]) return;
      document.querySelectorAll(entry[0]).forEach(function (element) { if (element.textContent !== entry[1]) element.textContent = entry[1]; });
    });
    document.querySelectorAll('.abibo-wl-card a[href], #abibo-wl-header-icon[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (arabic && /^\/(products|pages)\//.test(href)) link.setAttribute('href', '/ar' + href);
    });
    // Inventory alone does not determine whether a meal is on this week's menu.
    document.querySelectorAll('.abibo-wl-stk').forEach(function (label) {
      var text = arabic ? 'راجع التوفر في صفحة المنتج' : 'Check availability on product page';
      if (label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('.abibo-wl-chips [data-f="in"]').forEach(function (button) { button.hidden = true; });
    document.querySelectorAll('.abibo-wl-card').forEach(function (card) {
      var title = card.querySelector('.abibo-wl-title');
      localizeTitle(card, title);
      var name = title ? title.textContent.trim() : '';
      card.querySelectorAll('.abibo-wl-img, .abibo-wl-open').forEach(function (link) { link.setAttribute('aria-label', (arabic ? 'افتح ' : 'Open ') + name); });
      var remove = card.querySelector('[data-abibo-wl-remove]');
      if (remove) remove.setAttribute('aria-label', (arabic ? 'شيل ' : 'Remove ') + name);
    });
    if (arabic) {
      var translations = {'All':'الكل','On sale':'عروض','Featured':'المميزة','Price: low to high':'السعر: من الأقل للأعلى','Price: high to low':'السعر: من الأعلى للأقل','Name':'الاسم'};
      document.querySelectorAll('.abibo-wl-controls button, .abibo-wl-controls option').forEach(function (el) {
        var translated = translations[el.textContent.trim()];
        if (translated) el.textContent = translated;
      });
      document.querySelectorAll('.abibo-wl-sort').forEach(function (label) {
        Array.from(label.childNodes).forEach(function (node) { if (node.nodeType === 3 && node.textContent.trim() === 'Sort:') node.textContent = 'ترتيب: '; });
      });
    }
    document.querySelectorAll('[data-abibo-wl-addall]').forEach(function (button) { button.hidden = true; button.disabled = true; });
    document.querySelectorAll('.abibo-wl-card .abibo-wl-atcf').forEach(function (form) {
      var href = destination(form.closest('.abibo-wl-card'));
      if (!href) return;
      var link = document.createElement('a');
      link.className = 'abibo-wl-atc';
      link.href = href;
      link.textContent = document.documentElement.lang.indexOf('ar') === 0 ? 'عرض الخيارات' : 'View options';
      form.replaceWith(link);
    });
  }
  function start() {
    refresh();
    new MutationObserver(refresh).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();


